import { ObservationService } from '../../shared/observation/observation.service';
import { SalesOpportunityEditComponent } from '../sales-opportunity-edit/sales-opportunity-edit.component';
import { SalesOpportunityService } from '../shared/sales-opportunity.service';
import { SalesOpportunityDto } from '../shared/dto/sales-opportunity.dto';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ProfileMin } from 'src/app/profiles/shared/profile-min.model';
import { PagedResultGeneric, NotificationService } from 'src/app/shared';

@Component({
  selector: 'wl-sales-opportunity-edit-dialog',
  templateUrl: './sales-opportunity-edit-dialog.component.html',
  styleUrls: ['./sales-opportunity-edit-dialog.component.less'],
    standalone: false
})
export class SalesOpportunityEditDialogComponent implements OnInit {
  @Input()
  get show() {
    return this._show;
  }
  set show(value: boolean) {
    this._show = value;
    if (!value) {
      this.salesOpportunity = null;
    }
    this.showChange.emit(this._show);
  }
  @Output() showChange: EventEmitter<boolean> = new EventEmitter();
  @ViewChild(SalesOpportunityEditComponent) editComponent: SalesOpportunityEditComponent;
  profileResults: PagedResultGeneric<ProfileMin>;
  salesOpportunity: SalesOpportunityDto;
  isSaving = false;
  loadingSalesOpp = false;

  private _show: boolean;

  constructor(
    private _salesOpportunityService: SalesOpportunityService,
    private _notificationService: NotificationService,
    private _observationService: ObservationService
  ) {}

  ngOnInit(): void {}

  public open(salesOpportunityId?: number) {
    if (salesOpportunityId) {
      this.loadSalesOpportunity(salesOpportunityId);
    }
    this.show = true;
  }

  public openWithProfileId(profileId: number) {
    this.salesOpportunity = { SalesID: 0, ProfileID: profileId } as SalesOpportunityDto;
    this.show = true;
  }

  setResults(profileResults: PagedResultGeneric<ProfileMin>) {
    this.profileResults = profileResults;
  }

  save() {
    this.isSaving = true;
    let crudPromise;
    if (this.salesOpportunity.SalesID) {
      crudPromise = this._salesOpportunityService.update(this.salesOpportunity);
    } else {
      crudPromise = this._salesOpportunityService.create(this.salesOpportunity);
    }
    crudPromise
      .then(
        () => {
          this._notificationService.translateSuccess('sales-opportunities.edit.saved-successfully');
          this._observationService.profileUpdated(this.salesOpportunity.ProfileID);
          this.show = false;
        },
        (error) => {
          this._notificationService.httpError(error);
        }
      )
      .finally(() => (this.isSaving = false));
  }

  private loadSalesOpportunity(salesOppId: number) {
    this.loadingSalesOpp = true;
    this._salesOpportunityService.get(salesOppId).then((salesOpp) => {
      this.salesOpportunity = salesOpp;
      this.loadingSalesOpp = false;
    });
  }
}
